import * as React from 'react'

import { Skeleton } from '@thg-commerce/gravity-elements'
import { spacing, styled } from '@thg-commerce/gravity-theme'

import {
  Content,
  FacetSectionsContainer,
  Header,
  MobileFacetsContainer,
} from './styles'

const StyledSkeleton = styled(Skeleton)<{
  width?: number
  height?: number
  marginBottom?: number
}>`
  width: ${(props) => props.width || 100}%;
  height: ${(props) => props.height || 24}px;
  margin-bottom: ${(props) =>
    props.marginBottom ? spacing(props.marginBottom) : 0};
`

export const MobileFacetSkeleton = () => {
  return (
    <MobileFacetsContainer showMobileFacets={true}>
      <Header>
        <StyledSkeleton width={100} height={24} />
      </Header>
      <Content>
        <FacetSectionsContainer>
          {Array(4)
            .fill(null)
            .map((_, index) => (
              <div key={`skeleton-${index}`} style={{ padding: '16px' }}>
                <StyledSkeleton width={120} height={24} marginBottom={16} />
                {Array(3)
                  .fill(null)
                  .map((_, subIndex) => (
                    <StyledSkeleton
                      key={`option-${subIndex}`}
                      width={160}
                      height={20}
                      marginBottom={8}
                    />
                  ))}
              </div>
            ))}
        </FacetSectionsContainer>
      </Content>
    </MobileFacetsContainer>
  )
}
